import React, { useState, useEffect, useMemo } from 'react';
import SingerListItem from './../items/SingerListItem';
import Divider from '@mui/material/Divider';
import ClearIcon from '@mui/icons-material/Clear';
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import TR from './../../Trans';
import Grid from '@mui/material/Grid';
import { Views } from './../../enums/enums';
import TextField from '@mui/material/TextField';
import IntervalService from './../../services/intervals';
import List from '@mui/material/List';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import IconButton from '@mui/material/IconButton';
import AddSinger from './../dialogs/AddSinger';
import { checkIfMobile } from '../../services/screen';
import AddPerformance from './../dialogs/AddPerformance';
import Waiting from './../items/Waiting';
import { useMediaQuery } from 'react-responsive';
import ContentContainer from './../items/ContentContainer';
import DeleteDialog from './../dialogs/DeleteDialog';
import MuvikaService from './../../services/muvika';
import EditSinger from './../dialogs/EditSinger';
import settingsStore from '../../stores/settings';
import { useBottomScrollListener } from 'react-bottom-scroll-listener';
import sessionStore from './../../stores/session';
import performanceStore from '../../stores/performance';
import singersStore from './../../stores/singers';
import messageStore from './../../stores/message';
import playerStore from '../../stores/player';
import favoritesStore from './../../stores/favorites';
import navigationStore from '../../stores/navigation';
import accountStore from '../../stores/account';

function Singers() {

  const [isAddSingerOpen, setIsAddSingerOpen] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [isEditSingerDialogOpen, setIsEditSingerDialogOpen] = useState(false);
  const [chosenSinger, setChosenSinger] = useState(null);
  const [isAddPerformanceOpen, setIsAddPerformanceOpen] = useState(false);
  const [chosenTrack, setChosenTrack] = useState({});

  const sessionToken = sessionStore((state) => state.sessionToken);
  const isWaiting = singersStore((state) => state.isWaiting);
  const totalCount = singersStore((state) => state.totalCount);
  const singers = singersStore((state) => state.singers);
  const getSingers = singersStore((state) => state.getSingers);
  const getSingersMore = singersStore((state) => state.getSingersMore);
  const createSinger = singersStore((state) => state.createSinger);
  const deleteSinger = singersStore((state) => state.deleteSinger);
  const isSingersSet = singersStore((state) => state.isSet);
  const editSinger = singersStore((state) => state.editSinger);
  const isFinished = singersStore((state) => state.isFinished);
  const addPerformanceToPlayQueue = performanceStore((state) => state.addPerformanceToPlayQueue);
  const addPerformanceToPlayList = performanceStore((state) => state.addPerformanceToPlayList);
  const getPlayLists = performanceStore((state) => state.getPlayLists);
  const playLists = performanceStore((state) => state.playLists);
  const isPlayListsSet = performanceStore((state) => state.isSet);
  const isPlaying = playerStore((state) => state.isPlaying);
  const getStreamUrl = playerStore((state) => state.getStreamUrl);
  const setPlayIsOn = performanceStore((state) => state.setPlayIsOn);
  const setIsPlaying = playerStore((state) => state.setIsPlaying);
  const playQueue = performanceStore((state) => state.playQueue);
  const isInIosExternalScreen = playerStore((state) => state.isInIosExternalScreen);
  const getPlayQueue = performanceStore((state) => state.getPlayQueue);
  const setIsStopped = playerStore((state) => state.setIsStopped);
  const getFavorites = favoritesStore((state) => state.getFavorites);
  const favorites = favoritesStore((state) => state.tracks);
  const setError = messageStore((state) => state.setError);
  const setIsAutoPlayOn = playerStore((state) => state.setIsAutoPlayOn);
  const settings = settingsStore((state) => state.settings);
  const getSettings = settingsStore((state) => state.getSettings);
  const setIsSwitching = playerStore((state) => state.setIsSwitching);
  const setMobilePlayerVisible = navigationStore((state) => state.setMobilePlayerVisible);
  const goToView = navigationStore((state) => state.goToView);
  const accountLang = accountStore((state) => state.account?.language);

  const [searchQuery, setSearchQuery] = useState(null);
  const [filteredSingers, setFilteredSingers] = useState(null);

  useEffect(() => { }, [accountLang]);

  useEffect(() => {
    if (!isSingersSet) {
      getSingers(sessionToken);
    }
    if (!isPlayListsSet) {
      getPlayLists(sessionToken);
    }
    if (!favorites) {
      getFavorites(sessionToken);
    }
    if (!settings) {
      getSettings(sessionToken);
    }
  }, []);

  useEffect(() => {
    if (singers) {
      setFilteredSingers(singers.filter(singer => searchQuery ? singer.name.toLowerCase().includes(searchQuery.toLowerCase()) : true));
    }
  }, [singers]);

  const handleOpenAddSinger = () => {
    setIsAddSingerOpen(true);
  };

  const handleCloseAddSinger = () => {
    setIsAddSingerOpen(false);
  };

  const handleOpenDeleteDialog = () => {
    setIsDeleteDialogOpen(true);
  };

  const handleCloseDeleteDialog = () => {
    setIsDeleteDialogOpen(false);
  };

  const handleOpenEditSingerDialog = () => {
    setIsEditSingerDialogOpen(true);
  };

  const handleCloseEditSingerDialog = () => {
    setIsEditSingerDialogOpen(false);
  };

  const handleOpenAddPerformance = (track) => {


    MuvikaService.getLastPerformance(sessionToken, track.track_id)
      .then(function (res) {
        if (res.data.error) {
          setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          track.last_pitch = res.data.data.pitch;
          track.last_singer_id = res.data.data.profile_id;
          setChosenTrack(track);
          setIsAddPerformanceOpen(true);
        }
      })
      .catch(function () { });
  };

  const handleCloseAddPerformance = () => {
    setIsAddPerformanceOpen(false);
  };

  const handleScrollDown = () => {
    getSingersMore(sessionToken);
  };

  const isMobile = useMediaQuery({ query: '(max-width: 720px)' });

  const handleAddPerformance = (singerProfile, pitch, playList, toPos, isManual, playNow = false, isSongbookQueue = false) => {
    if (singerProfile && (pitch >= -3 && pitch <= 3)) {
      if (playList) {
        addPerformanceToPlayList(sessionToken, chosenTrack, singerProfile, pitch, playList.id, toPos);
        setIsAddPerformanceOpen(false);
      } else {
        if (isSongbookQueue) {
          MuvikaService.createSongRequest(sessionToken, "add", chosenTrack.track_id, singerProfile.id, pitch, [])
            .then(function (res) {
              if (res.data.error) {
                setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
              }
            })
            .catch(function () { });
          setIsAddPerformanceOpen(false);
        } else {
          setIsAutoPlayOn(settings.autoplay_enabled);
          addPerformanceToPlayQueue(sessionToken, chosenTrack, singerProfile, pitch, toPos, isManual, playNow);
          setIsAddPerformanceOpen(false);
        }
      }
      if (toPos == 0 && playNow) {
        IntervalService.clearAllIntervals();
        setIsAutoPlayOn(false);
        setIsSwitching(true);
        let isMobile = checkIfMobile();
        if (isMobile) {
          goToView(Views.Blank);
          setMobilePlayerVisible(true);
        }
      }
    } else {
      setError(sessionToken, 0, TR.cm_select_singer);
    }
  };

  const singerList = useMemo(() => {
    if (singers) {
      return filteredSingers?.map((singer, index) =>
        <SingerListItem
          key={singer.id}
          name={singer.name}
          highlight={searchQuery}
          favorites={favorites}
          created={singer.created}
          trackStats={singer.track_stats}
          onAddPerformance={handleOpenAddPerformance}
          openDeleteDialog={(e) => {
            e.stopPropagation();
            setChosenSinger(singer);
            handleOpenDeleteDialog();
          }}
          openSingerEditDialog={(e) => {
            e.stopPropagation();
            setChosenSinger(singer);
            handleOpenEditSingerDialog();
          }}
        />
      );
    }
  }, [filteredSingers]);

  const handleSingerCreation = (singerName, gender, email) => {
    if (singerName.length > 0) {
      createSinger(sessionToken, singerName.trim(), gender, email);
      setIsAddSingerOpen(false);
    } else {
      setError(sessionToken, 0, TR.cm_name_cannot_be_empty);
    }
  };

  const handleDeletion = () => {
    if (chosenSinger) {
      deleteSinger(sessionToken, chosenSinger.id);
      getPlayQueue();
    }
    setIsDeleteDialogOpen(false);
  };

  const handleEdit = (singerName, gender, email) => {
    if (chosenSinger && singerName.length > 0) {
      editSinger(sessionToken, chosenSinger.id, singerName, gender, email);
    }
    setIsEditSingerDialogOpen(false);
  };

  const waitingRender = () => {
    if (isWaiting) {
      return <Waiting />;
    }
  };

  const handleSearch = (e) => {
    let query = e.target.value;
    setSearchQuery(query);
    if (singers) {
      setFilteredSingers(singers.filter(singer => query ? singer.name.toLowerCase().includes(query.toLowerCase()) : true));
    }
  };

  const clearQuery = () => {
    setSearchQuery(null);
    if (singers) {
      setFilteredSingers(singers);
    }
  }

  const renderClearAdorment = () => {
    return <InputAdornment position="end">
      <IconButton onClick={() => clearQuery()}>
        <ClearIcon />
      </IconButton>
    </InputAdornment>;
  };

  const renderStartAdorment = () => {
    return <InputAdornment position="start">
      <IconButton>
        <SearchIcon />
      </IconButton>
    </InputAdornment>;
  };

  const renderSearchField = () => {
    return <TextField
      className={"muvika-search-filter"}
      onChange={handleSearch}
      size="small"
      value={searchQuery ? searchQuery : ""}
      placeholder={TR.cm_find}
      InputProps={{
        endAdornment: (
          renderClearAdorment()
        )
      }}
    />;
  };

  const contentRender = () => {
    return <div>
      <Grid container spacing={0}>
        <Grid item xs={5}>
          <p>
            {TR.cm_total}: {filteredSingers?.length}
          </p>
        </Grid>
        <Grid item xs={7} sx={{ textAlign: "right" }}>
          {renderSearchField()}
        </Grid>
      </Grid>
      <ContentContainer id="singer-list" isFinished={isFinished} onScrollDown={handleScrollDown}>
        <List className="muvika-singers-container-list">
          {singerList}
          {waitingRender()}
        </List>
      </ContentContainer>
    </div>;
  };

  return (
    <div>
      <EditSinger
        open={isEditSingerDialogOpen}
        onClose={handleCloseEditSingerDialog}
        onEdit={handleEdit}
        singerName={chosenSinger ? chosenSinger.name : ""}
        gender={chosenSinger ? chosenSinger.gender : ""}
        email={chosenSinger ? chosenSinger.email : ""}
      />
      <DeleteDialog
        openToLeft={true}
        open={isDeleteDialogOpen}
        onClose={handleCloseDeleteDialog}
        onDeletion={handleDeletion}
        title={TR.cm_are_you_sure}
        cancel={TR.cm_cancel}
        delete={TR.cm_delete}
      />
      <AddSinger open={isAddSingerOpen} isPerformanceAdd={false} onClose={handleCloseAddSinger} onSingerCreation={handleSingerCreation} />
      <AddPerformance
        open={isAddPerformanceOpen}
        onClose={handleCloseAddPerformance}
        onAddPerformance={handleAddPerformance}
        track={chosenTrack}
        singers={singers}
        playLists={playLists}
        isPlaying={isPlaying.isPlaying}
        playQueue={playQueue}
      />
      <Grid container spacing={0}>
        <Grid item xs={11}>
          <h3>{TR.cm_singers}</h3>
        </Grid>
        <Grid item xs={1}>
          <IconButton className="muvika-button-right" color="white" component="label" onClick={handleOpenAddSinger}>
            <AddCircleIcon />
          </IconButton>
        </Grid>
      </Grid>
      {contentRender()}
    </div>
  );
}

export default Singers;